/* SPH – Verkaufsbild hinter die erste Ueberschrift der Beschreibung setzen */
(function () {
  function go() {
    document.querySelectorAll('.sph-tabp figure').forEach(function (f) {
      var st = f.getAttribute('style') || '';
      if (st.indexOf('float') === -1 || f.hasAttribute('data-sph-img')) return;
      f.setAttribute('data-sph-img', '1');
      var c = f.parentElement;
      if (!c) return;
      var h = c.querySelector('h2, h3');
      if (h && (h.compareDocumentPosition(f) & Node.DOCUMENT_POSITION_PRECEDING)) {
        h.insertAdjacentElement('afterend', f);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', go);
  } else {
    go();
  }
})();
